"use client";

import { Button, Image, Video } from "@opensea/next-ui-kit";
import { classNames, Flex } from "@opensea/ui-kit";
import { Pause, PlayArrow } from "@opensea/ui-kit/icons";
import { useId, useRef, useState } from "react";
import { stopPlaying } from "@/lib/utils";
import { useItemsMediaContext } from "../../ItemsMediaContext";
export function ItemCardVideo({
  src,
  size,
  title,
  variant,
  className,
  onLoad,
  onAspectRatioChange,
  surface
}) {
  const id = useId();
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const videoRef = useRef(null);
  const activeVideoRef = useItemsMediaContext();
  const aspectRatio = width / (height || width) || 1;
  return <Flex className="size-full" style={{
    aspectRatio
  }}>
      {isPlaying ? <Video autoPlay className={classNames("size-full object-contain", className)} controls controlsList="nodownload" format={variant.format} id={id} loop onLoadedData={e => {
      onLoad?.();
      setWidth(e.currentTarget.videoWidth);
      setHeight(e.currentTarget.videoHeight);
      onAspectRatioChange?.(e.currentTarget.videoWidth, e.currentTarget.videoHeight);
    }} onPause={() => {
      setIsPlaying(false);
    }} onPlay={() => {
      activeVideoRef.current = videoRef.current;
    }} onPlaying={() => {
      stopPlaying(id);
    }} playsInline preload="metadata" ref={videoRef} src={`${src}#t=0.001`} title={title} width={size} /> : <Image alt={title} className={classNames("size-full object-contain", className)} frameTime={1} onLoad={e_0 => {
      onLoad?.();
      setWidth(e_0.currentTarget.naturalWidth);
      setHeight(e_0.currentTarget.naturalHeight);
      onAspectRatioChange?.(e_0.currentTarget.naturalWidth, e_0.currentTarget.naturalHeight);
    }} src={src} width={size} />}

      {surface !== "static" ? <Button className="absolute right-4 bottom-4 z-50" icon={isPlaying ? Pause : PlayArrow} onClick={event => {
      event.preventDefault();
      event.stopPropagation();
      if (isPlaying) {
        setIsPlaying(false);
      } else {
        activeVideoRef.current?.pause();
        setIsPlaying(true);
      }
    }} rounded variant="secondary" /> : null}
    </Flex>;
}